import { useLocation, useNavigate } from 'react-router-dom';
import { Button, TextInput, PasswordInput, Flex, Loader } from '@mantine/core';

import { useAuth } from '../auth/AuthContext';

export const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();

  const from = location.state?.from?.pathname || '/api-keys';

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const username = formData.get('username') as string;
    const password = formData.get('password') as string;

    auth?.signin(username, password, () => {
      // Send them back to the page they tried to visit when they were
      // redirected to the login page. Use { replace: true } so we don't create
      // another entry in the history stack for the login page.  This means that
      // when they get to the protected page and click the back button, they
      // won't end up back on the login page, which is also really nice for the
      // user experience.
      navigate(from, { replace: true });
    });
  }

  if (!auth || auth.validating) {
    // If we're validating the user's session, show a loading spinner
    return (
      <Flex align="center" justify="center" mih={300} w="100%">
        <Loader />
      </Flex>
    );
  }

  return auth.user ? (
    <div>
      <p>Signed in</p>
    </div>
  ) : (
    <div>
      <p>You must log in to view this page </p>

      {auth?.error ? (
        <p style={{ color: 'red', fontWeight: 'bold' }}>ERROR: {auth.error}</p>
      ) : null}

      <form onSubmit={handleSubmit}>
        <TextInput name="username" type="text" label="Username: " />
        <PasswordInput name="password" type="password" label="Password: " />
        <Button variant="filled" type="submit" mt="md">
          Login
        </Button>
      </form>
    </div>
  );
};
